import { render, staticRenderFns } from "./TestPaperComponent.vue?vue&type=template&id=54171a2e&"
import script from "./TestPaperComponent.vue?vue&type=script&lang=js&"
export * from "./TestPaperComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\vsProject\\dsf-product-exam\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54171a2e')) {
      api.createRecord('54171a2e', component.options)
    } else {
      api.reload('54171a2e', component.options)
    }
    module.hot.accept("./TestPaperComponent.vue?vue&type=template&id=54171a2e&", function () {
      api.rerender('54171a2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "pc/components/TestPaperComponent.vue"
export default component.exports